import request from '@/request'

const getCookieDomain = () => {
  const domain = process.env.VUE_APP_DOMAIN || window.location.hostname.replace('www.', '')
  return domain
}

const storeToken = (token) => {
  if (token) {
    document.cookie = `cc_legacy_token=${token}; domain=.${getCookieDomain()}; path=/;`;
    localStorage.setItem('token', token)
  }
}

const getToken = () => {
  const token = localStorage.getItem('token')

  if (token) {
    document.cookie = `cc_legacy_token=${token}; domain=.${getCookieDomain()}; path=/;`;
  }

  return token
}

const removeToken = () => {
  if (localStorage.getItem('token')) {
    document.cookie = `cc_legacy_token=null; domain=.${getCookieDomain()}; path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
  }
  return localStorage.removeItem('token')
}

const register = async (data) => {
  return await request({
    url: '/auth/register',
    method: 'post',
    data
  })
}

const login = async (data) => {
  return await request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

const requestResetPassword = async (email) => {
  return await request({
    url: '/auth/reset-password',
    method: 'post',
    data: { email }
  })
}

const changePasswordByReset = async (data) => {
  return await request({
    url: '/auth/reset-password/change',
    method: 'post',
    data
  })
}

const loginGoogle = async (token) => {
  return await request({
    url: '/auth/google',
    method: 'post',
    data: { token }
  })
}

const loginFacebook = async (token) => {
  return await request({
    url: '/auth/facebook',
    method: 'post',
    data: { token }
  })
}

const getUserByToken = async () => {
  const response = await request({
    url: '/users/me',
    method: 'get'
  })

  return response.data.data
}

const getUserByRegistrationPendingToken = async (token) => {
  const response = await request({
    url: `/users/registration-pending/${token}`,
    method: 'get'
  })

  return response.data
}

const updateUserRegistrionPendingPassword = async(token, data) => {
  const response = await request({
    url: `/users/registration-pending/${token}`,
    method: 'post',
    data: {...data, '_method': 'PUT'}
  })

  return response.data
}

const logout = async() => {
  await request({
    url: `/auth/logout`,
    method: 'post'
  })
}

export default {
  storeToken,
  getUserByToken,
  removeToken,
  getToken,
  register,
  login,
  logout,
  loginGoogle,
  loginFacebook,
  requestResetPassword,
  changePasswordByReset,
  getUserByRegistrationPendingToken,
  updateUserRegistrionPendingPassword
}
